<template>
  <div data-app>
    <el-dialog
      class="dialogSearchFacility"
      :show-close="false"
      center
      :visible.sync="isShowDialog"
      :before-close="handleClose"
      :height="dialogMinHeight"
      :bottom="0"
    >
      <div class="wallet-container mb-20">
        <div style="position:relative;">
          <div style="padding-bottom: 0 !important;" class="container mt-3">
            <p class="title-dialog m-0">{{ $t("chooseFacility") }}</p>
            <img @click="handleClose" :src="bg.icon_closed" alt="" />
          </div>
          <div
            style="padding-bottom: 0 !important; padding-top:10px"
            class="search-container container"
          >
            <div class="full-width  search-bar-container">
              <img style="margin-left:10px" :src="bg.icon_search" alt="" />
              <el-input
                @input="handleSearchFacility"
                ref="inputSearchFacility"
                class="input-search-bar full-width"
                :placeholder="$t('wap.text29')"
                v-model="facilityName"
              >
              </el-input>
              <!-- <img
                @click="handleClose"
                class="mr-10"
                :src="icons.CloseIcon"
                alt=""
              /> -->
            </div>
          </div>
          <div
            style="min-height: 450px;"
            v-if="isLoading"
            v-loading="isLoading"
            class="full-width"
          ></div>
          <el-row
            v-else
            style="padding-top: 16px;"
            class="full-width container"
          >
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
              <div class="full-width">
                <div
                  v-if="listFacility.length > 0"
                  class="full-width golfContainer"
                >
                  <div
                    v-for="(item, index) in listFacility"
                    class="golf-course"
                    @click="handleActiveFacility(item)"
                    :key="item.id"
                    style="border-bottom: 0.81px solid var(--Border-Grey-Medium, #F6F6F6)"
                  >
                    <img
                      class="mr-10"
                      style="height: 38px; width:38px; object-fill: cover; border-radius: 50%; "
                      :src="item.logo || logoDefault"
                      @error="handleImageError(index)"
                      alt=""
                    />
                    <div class="info-golf-course full-width">
                      <h3 class="name-course fs-cv3 c-text-main">
                        {{ item.title }}
                      </h3>
                      <p class="address-course fs-cv4">
                        {{ item.address }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-else class="full-width mt-20">
                  <p class="c-black-text text-align-center">
                    {{ $t("notFoundMessage") }}
                  </p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBackGround } from "@/utils/wapAuth";
import { formatNumber } from "@/plugins/init";
import GlobalAPI from "@/views/api/wapV2/global";
import { isEmpty } from "@/utils/validate";
import { toggleChat } from "@/utils/helper";
export default {
  name: "dialogSearchFacility",
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    isViewsPrice: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isLoading: false,
      longitude: null,
      latitude: null,
      logoDefault:
        "https://web-api.vcallid.com/static/uploads/ab5733a5-96d4-445f-afb2-2b42d26a5805.png",
      facilityName: "",
      listFacility: [],
      bg: getBackGround(),
      isMobile: true,
      icons: {}
    };
  },
  created() {},

  computed: {
    dialogMinHeight() {
      return window.innerHeight * 0.9 + "px";
    }
  },
  watch: {
    isShowDialog: function(newValue, oldValue) {
      if (newValue) {
        this.hideOverflow();
        toggleChat(false);
        if (this.listFacility.length > 0) return;
        this.requestUserLocation();
      } else {
        toggleChat(true);
        this.showOverflow();
      }
    }
  },
  mounted() {},
  methods: {
    formatNumber,
    hideOverflow() {
      const dBody = document.body;
      if (!this.isViewsPrice) {
        dBody.style.position = "fixed";
        dBody.style.height = "100%";
        dBody.style.overflow = "hidden";
        dBody.style.width = "100%";
      }
    },
    showOverflow() {
      const dBody = document.body;
      dBody.style.position = "";
      dBody.style.height = "";
      dBody.style.width = "";
      dBody.style.overflow = "";

      document.documentElement.style.overflow = "";
    },
    handleActiveFacility(row) {
      if (row) {
        this.facilityName = "";
        this.$emit("item-facility", { value: row.id, label: row.title });
      }
    },
    handleImageError(index) {
      // Xử lý khi đường dẫn ảnh không hợp lệ
      // Thay thế đường dẫn ảnh bằng đường dẫn hình ảnh mặc định
      this.listFacility[index].logo = this.logoDefault;
    },
    requestUserLocation() {
      if (this.longitude && this.latitude) {
        this.requestSearchFacilityNearby(this.longitude, this.latitude);
        return;
      }
      if (navigator.geolocation) {
        this.isLoading = true;
        navigator.geolocation.getCurrentPosition(
          position => {
            if (position && position.coords) {
              const longitude = position.coords.longitude;
              const latitude = position.coords.latitude;
              this.longitude = longitude;
              this.latitude = latitude;
              this.requestSearchFacilityNearby(longitude, latitude);
            } else {
              this.handleSearchFacility();
            }
          },
          () => {
            this.handleSearchFacility();
          }
        );
      } else {
        this.handleSearchFacility();
      }
    },
    requestSearchFacilityNearby(longitude, latitude) {
      GlobalAPI.facilityNearby({ longitude, latitude })
        .then(response => {
          if (response.error_code === 0) {
            this.listFacility = response.data.facilities;
            // console.log("sân", this.listFacility);
          } else {
            this.listFacility = [];
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async handleSearchFacility(val = "c") {
      // this.isLoading = true
      GlobalAPI.searchFacility({
        q: isEmpty(val) ? "c" : val.trim(),
        page: 1,
        limit: 10
      })
        .then(res => {
          if (res.error_code === 0) this.listFacility = res.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleClose() {
      this.requestUserLocation();
      this.facilityName = "";
      this.$emit("close", true);
      // this.$store.dispatch("show_dialog_search_facility", false);
    }
  }
};
</script>
<style lang="scss">
$color_slider: v-bind("bg.c_button_main");
// $color_radio_check: v-bind("bg.c_inherit_text");
$color_radio_check: v-bind("bg.c_button_main");
$color_slider_bar: #d9d9d9;

.mt-15 {
  margin-top: 15px !important;
}
.mb-15 {
  margin-bottom: 15px !important;
}
.dialogSearchFacility .el-dialog {
  position: relative;
  border-radius: 10px;
  min-height: 10vh;
  overflow: hidden;
  max-width: 500px !important;
  width: 100%;
  z-index: 2100;
  height: 70vh;
  margin-bottom: 0 !important;
  margin-top: 10vh !important;

  .el-dialog__body {
    padding-top: 0 !important;
    padding-bottom: 0px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .el-dialog__header {
    margin: 0;
    padding: 0;
  }
}
.el-tooltip__popper {
  display: none !important;
}

@media screen and (min-width: 0px) and (max-width: 600px) {
  .dialogSearchFacility .el-dialog {
    position: fixed;
    bottom: 0;
    margin-top: 20vh !important;
    border-radius: 20px;
    overflow: hidden;
    max-width: 550px !important;
    width: 100%;
    height: 60vh;
    z-index: 2100;

    margin-bottom: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}
@media screen and (min-width: 0px) and (max-width: 380px) {
  .dialogSearchFacility .el-dialog {
    position: fixed;
    bottom: 0;
    margin-top: 10vh !important;
    border-radius: 30px;
    background: rgba(240, 241, 245, 1);
    height: 60vh;
    overflow: hidden;
    max-width: 550px !important;
    width: 100%;

    margin-bottom: 0 !important;
    z-index: 2100;

    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}
@media screen and (max-width: 320px) and (max-height: 568px) {
  .dialogSearchFacility .el-dialog {
    margin-top: 10vh !important; /* Giảm khoảng cách từ trên xuống */
    height: 60vh;
    bottom: 0;
    min-height: auto; /* Bỏ giá trị cố định cho chiều cao tối thiểu */
    max-height: none; /* Bỏ giới hạn chiều cao tối đa */
    max-width: 100% !important; /* Đặt chiều rộng tối đa là 100% */
    border-radius: 0; /* Loại bỏ viền bo tròn */
    z-index: 2100;
  }
}
</style>

<style lang="scss" scoped>
$divider-color: #ececec;

$color-btn: v-bind("bg.c_button_main");
.title-dialog {
  color: var(--Foreground-Ink-Default, #1a1a1a);

  font-weight: 600;
  font-size: 14.56px;
  line-height: 19.41px;
  letter-spacing: 0%;
}
.golfContainer {
  max-height: 420px;
  overflow-y: scroll; /* Để cho phép cuộn theo chiều dọc */
  scrollbar-width: none; /* Ẩn thanh cuộn trong Firefox */
}
/* Ẩn thanh cuộn trong Chrome, Safari và Opera */
.golfContainer::-webkit-scrollbar {
  display: none;
}
.search-bar-container {
  border: 0.87px solid v-bind("bg.c_border3");
  background: v-bind("bg.c_background1");
  border-radius: 100px;
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
}
.info-golf-course {
  position: relative;
  padding-right: 20px;
  padding-bottom: 10px;
}
.address-course {
  color: #999999;
  font-size: 12px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
  height: 20px;
}
.name-course {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  font-weight: 500;
  max-width: 90%;
}
.golf-course {
  cursor: pointer;
  overflow: hidden;
  padding: 0;
  display: flex;
  margin-bottom: 10px;
}
.divider-view {
  height: 2px;
  width: 100%;
  margin: 5px 0;
  background-color: $divider-color;
}

.w-100 {
  width: 100%;
}
.mr-10 {
  margin-right: 10px;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 769px) and (max-width: 980px) {
}
</style>
